import {initYandexMap} from "./initYandexMap";
import {API_MAP_KEY, MAPS} from "./constants";

export const initDivMap = () => {
	if ( document.querySelector(`div.map`) )
	{
		const script = document.createElement(`script`);
		script.src = API_MAP_KEY;
		document.body.appendChild(script);
		script.addEventListener(`load`, () => {
			// initYandexMap();
			ymaps.ready( () => {
				MAPS.forEach( initYandexMap );
			});
		});
	}
};
